import { useMutation } from '@vue/apollo-composable';
import gql from 'graphql-tag';
import useAlerts from './useAlerts';

const { addAlert } = useAlerts();

const USER_PROFILE_MUTATION = gql`
  mutation UpdateUserProfile($user: TBL_USERS_Input) {
    updateUserProfile(user: $user)
  }
`;

export default function useUpdateUserProfile() {
  const { mutate, loading, error } = useMutation(USER_PROFILE_MUTATION);

  async function updateUserProfile(user) {
    try {
      const { data } = await mutate({ user: user });
      return data;
    } catch (error) {
      console.error('Error updating user profile:', error);
      addAlert('Error updating user profile', 'high', 4);
    }
  }

  return {
    updateUserProfile,
    loading,
    error,
  };
}
